import type { FaireProductEntity } from "../../entity_types/product";

export const p_7up8ysrpev: FaireProductEntity = {
  token: "p_7up8ysrpev",
  type: "product",
  name: "Windproof 24 Ribs Japanese Katana Umbrella Black",
  brandToken: "b_m8c3mbnsfa",
  brandName: "Urban Tokyo",
  imageUrl: "https://cdn.faire.com/fastly/b796716d96211b648a795b8726d1a7c56c23455212fba7cd538656bb4d976362.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/be8896caafc5934ea6c173adc11c43f4210ad841a11985e0402cbec1bf55fc8c.png"
  ],
  priceDollars: 15,
  description: "Bring a touch of samurai style to rainy days with this Windproof 24 Ribs Japanese Katana Umbrella in black. The handle is shaped like the grip of a Japanese katana sword, turning an everyday essential into a conversation piece, while the reinforced 24-rib frame holds its shape in gusty wind and heavy rain.\n\nFeatures\n\n * Windproof 24-rib frame – twice the ribs of a standard umbrella for extra strength and stability in harsh weather \n * Katana sword-style handle – a comfortable, distinctive grip inspired by the Japanese samurai sword \n * Durable nylon canopy – sleek black finish that sheds rain and suits any outfit \n * Large coverage – generous canopy keeps you dry from shoulders to bag \n * Great gift – a fun, practical present for anime fans, Japan lovers and martial arts enthusiasts \nIdeal For\n\nEveryday commuting, travel and gifting. Retailers, gift shops and Japanese restaurants can stock it as an eye-catching novelty item that sells year-round; it also pairs well with the rest of our Windproof 24 Ribs Japanese umbrella series.\n\nSpecifications\n\n * Size: 50.75\" x 42.5\" \n * Color: Black \n * Material: Nylon \n * Ribs: 24 \n * Country of Origin: China \n * Case Pack: 12 ",
  tags: [],
  msrpDollars: 33.75,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-28T21:03:06.753Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
